import React from 'react';
import { Navigate } from 'react-router-dom';
import { checkSession } from '../config/authConfig';

const ProtectedRoute = ({ children }) => {
  if (!checkSession()) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

export default ProtectedRoute;
